// extracted by mini-css-extract-plugin
var _1 = "pqPgwGU5ES9fNN5WLGrf";
export { _1 as "root" }
